<template>
  <luma-button-wrapper >
    <template v-slot:button>
      <b-button class="col-12"
                @click="save()"
                variant="primary" >
        <h3 v-if="!spinner">{{text ? text : 'Änderungen speichern'}}</h3>
        <b-spinner v-else></b-spinner>
      </b-button>
    </template>
  </luma-button-wrapper>
</template>

<script>
    import LumaButtonWrapper from "./luma-button-wrapper";
    export default {
        name: "luma-save-changes-button",
        components: {LumaButtonWrapper},
        props:{
            spinner:Boolean,
            text:String
        },
        methods:{
            save(){
                this.$emit('save')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/luma-save-changes-button.vue